import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({
  providedIn: 'root',
})
export class EnvTrainingService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      isMagellan: '1',
      _env: 'training',
      _apiUrl: 'https://training-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://training-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer:
        'https://pcisb2ctraining.b2clogin.com/4c8b49f4-2b1e-43e3-8a60-d5656540b568/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint:
        'https://pcisb2ctraining.b2clogin.com.b2clogin.com/pcisb2ctraining.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl:
        'https://pcisb2ctraining.b2clogin.com/pcisb2ctraining.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '50cb0011-2775-4c43-a640-798902777955',
      _scope:
        'openid profile https://pcisb2ctraining.onmicrosoft.com/api/pcis.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl:
        'https://pcisb2ctraining.b2clogin.com/pcisb2ctraining.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://training-login.p-cis.com/',
      _signInURL:
        'https://pcisb2ctraining.b2clogin.com/pcisb2ctraining.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO:
        'https://pcisb2ctraining.b2clogin.com/pcisb2ctraining.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl:
        'https://pcisb2ctraining.b2clogin.com/pcisb2ctraining.onmicrosoft.com/oauth2/v2.0/',
      _magicLink:
        'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _authEndpoint:'https://pcisb2ctraining.b2clogin.com/pcisb2ctraining.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope: 'https://pcisb2ctraining.b2clogin.com/pcisb2ctraining.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9ab0',
      _intercomAppId: 'bqgvwybf'
    };
  }
}
